import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { CategoriaConteudoService } from "../../../configuracoes/categoria-conteudo/categoria-conteudo.service";
import { CdkDrag, CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { NotificationsService } from "src/app/shared/notifications.service";
import { Ng7BootstrapBreadcrumbService } from "ng7-bootstrap-breadcrumb";


@Component({
  selector: "app-order-category",
  templateUrl: "./order-category.component.html",
  styleUrls: ["./order-category.component.scss"],
  providers: [CategoriaConteudoService],
})
export class OrderCategoryComponent implements OnInit {
  languageSubscription: Subscription;
  languages: any = [];
  categories: any = [];
  categoryId: any = []
  categoryFeatured: any = [];
 
  pageSize = 40;
  page = 0;
  language = "EN";
  sortDirection = "asc";
  filter: string = "";  

  constructor(
    public categoriaConteudoService: CategoriaConteudoService,
    private notifyService: NotificationsService,
    public dialog: MatDialog,
    private ng7BootstrapBreadcrumbService: Ng7BootstrapBreadcrumbService,
  ) {}

  ngOnInit() {
    const breadcrumbs = [
			{ label: 'Sesc Digital', url: '/', params: [] },
			{ label: 'Editar destaque categoria', url: '', params: [] }
    ]
	  
    this.ng7BootstrapBreadcrumbService.updateBreadcrumb(breadcrumbs);

    this.languageSubscription = this.categoriaConteudoService
      .getLanguages()
      .subscribe((res) => {
        res.content ? (this.languages = res.content) : (this.languages = res);
        this.languages = this.languages[2];
      });
    this.loadContent();     
  }

  ngOnDestroy() {
    this.languageSubscription.unsubscribe();
  }

  loadContent(){
    setTimeout(() =>{
      this.getActiveCategory();
      this.getContent();
    }, 1000)
  }

  getContent() {
    this.categoriaConteudoService
      .getContentCategory(
        this.language,
        this.sortDirection,
        this.page,
        this.pageSize,
        this.filter
      )
      .subscribe((response) => {
        this.categories = response.content;
        this.categories = this.categories.map((category) => {
          return category.titles.find((title) => {
            return title.language.id == this.languages.id;
          });
        });
      });
      
  }
  
  getActiveCategory(){
    this.categoriaConteudoService.getAllCategory().subscribe(res => {
      this.categoryFeatured = res;
        this.categoryFeatured =  this.categoryFeatured.map((category) => {
        return category.titles.find((title) => {
          return title.language
        })   
      });
    })
  }
  
  canAddCategory = (item: CdkDrag<any>) => {
    if (this.categoryFeatured.find((id) => id.contentCategoryId == item.data.contentCategoryId)) {
			return false
		} else {
			return true
		}
  }

  addCategory(event: CdkDragDrop<string[]>, category, item: CdkDrag<any>){
    if (event.previousContainer === event.container && category === 'featured') {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);  
      this.categoryId = this.categoryFeatured.map((ids) => {
        return  ids.contentCategoryId 
      })  
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
                        this.categoryId = this.categoryFeatured.map((ids) => {
                          return  ids.contentCategoryId
                        }) 
                        this.categoryId = this.categoryId.filter((id, i) => {
                          return this.categoryId.indexOf(id) === i;
                        }) 
    }
  }

  saveCategory(){
    if(this.categoryId.length === 0){
      this.categoryId = this.categoryFeatured.map((ids) => {
        return  ids.contentCategoryId
      }) 
    }

    return this.categoriaConteudoService.putCategoryId(this.categoryId).subscribe(
      result => {
        this.notifyService.showSuccess("Atualizado com sucesso", "Atualizado")
      },
      error => {
        this.notifyService.showError("Não foi possível salvar categoria", "Erro")
      }
    )
  }

  searchCategory(event){
    if(event){
      this.categories = this.categories.filter((category) => category.title.toLowerCase().indexOf(event.toLowerCase()) > -1 )
    }else{
      this.getContent();
    }
  }
}
